import {CommonMessages} from '../common.messages';

export const PanelSettingsFileImportMessages = {
    ConvertFileFailed: {
        key: 'ConvertFileFailed',
        message: 'Unable to parse imported file.'
    },
    FileValidationFailed: {
        key: 'FileValidationFailed',
        message: 'Unable to validate imported file.'
    },
    FileValidationErrorsOccurred: {
        key: 'FileValidationErrorsOccurred',
        message: 'File validation failed.<br/>'
    },
    FileImportFailed: {
        key: 'FileImportFailed',
        message: 'Unable to import file data.'
    },
    FileImportNotProcessedRows: {
        key: 'FileImportNotProcessedRows',
        message: 'The file is not fully imported. There are <<processedRows>> from <<totalRows>>. Rows <<rows>> are not imported.'
    },
    FileImportNoDataImported: {
        key: 'FileImportNoDataImported',
        message: 'There isn\'t new imported data.'
    },
    FileImportSucceed: {
        key: 'FileImportSucceed',
        message: 'File import is successful. In the system are imported: <<processedRows>> items.'
    },
    ...CommonMessages
};
